<script lang="ts">
  let props = $props()

  let {
    birthdays
  }: {
    birthdays: any[]
  } = props

  import birthday_img from "@images/users/birthday-cake.png"
</script>

{#if birthdays.current?.length > 0 || birthdays.upcoming?.length > 0}
  <div
    class="bg-indigo-50 p-8 grid grid-cols-3 mb-4 border border-gray-200 rounded-lg shadow-lg"
  >
    <div class="flex flex-col justify-center items-center">
      <img src={birthday_img} class="w-36 h-36" alt="Member Birthdays" />
      <p class="text-xl font-bold text-orange-800 text-center mt-8">
        Celebrating Team Member Birthdays!
      </p>
    </div>
    <div class="col-span-2">
      {#if birthdays.current.length > 0}
        <p class="text-xl font-bold text-orange-800 text-center">
          Team member birthdays this week
        </p>
        <ul
          role="list"
          class="mx-auto mt-4 max-w-2xl gap-x-12 gap-y-6 text-center lg:max-w-none flex justify-center items-center"
        >
          {#each birthdays.current as birthday}
            <li>
              <img
                class="mx-auto h-14 w-14 rounded-full shadow-xl border border-gray-100"
                src={birthday.avatar_url}
                alt={birthday.name}
              />
              <h3
                class="mt-2 text-base font-semibold tracking-tight text-gray-900"
              >
                {birthday.name}
              </h3>
              <p class="text-sm text-gray-600">
                {birthday.birthdate_simple}
              </p>
            </li>
          {/each}
        </ul>
      {/if}
      {#if birthdays.upcoming.length > 0}
        <p class="text-xl italic font-bold text-orange-800 text-center mt-6">
          Team members birthdays next week
        </p>
        <ul
          role="list"
          class="mx-auto mt-4 max-w-2xl gap-x-12 gap-y-6 text-center lg:max-w-none flex justify-center items-center"
        >
          {#each birthdays.upcoming as birthday}
            <li>
              <img
                class="mx-auto h-14 w-14 text-sm rounded-full shadow-xl border border-gray-100"
                src={birthday.avatar_url}
                alt={birthday.name}
              />
              <h3
                class="mt-2 text-base font-semibold tracking-tight text-gray-900"
              >
                {birthday.name}
              </h3>
              <p class="text-sm text-gray-600">
                {birthday.birthdate_simple}
              </p>
            </li>
          {/each}
        </ul>
      {/if}
    </div>
  </div>
{/if}
